<template>
  <transition name="fade">
    <div v-if="hasNotifications" class="clear-all-notifications">
      <v-btn
        small
        text
        color="primary"
        @click="clearAll"
        class="clear-all-btn"
      >
        <v-icon small left>mdi-close-circle-multiple</v-icon>
        Закрыть все
      </v-btn>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ClearAllNotificationsButton',
  
  data() {
    return {
      hasNotifications: false
    };
  },
  
  mounted() {
    // Наблюдаем за контейнером уведомлений
    this.observeNotifications();
    // Также проверяем периодически на случай если observer не сработал
    this.checkInterval = setInterval(() => {
      this.updateButtonVisibility();
    }, 500);
  },
  
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  },
  
  methods: {
    observeNotifications() {
      // Сразу проверяем
      this.updateButtonVisibility();
      
      // Ждем когда контейнер появится в DOM
      const checkContainer = setInterval(() => {
        const container = document.querySelector('.Vue-Toastification__container');
        if (container) {
          clearInterval(checkContainer);
          
          // Создаем observer для отслеживания изменений в контейнере
          this.observer = new MutationObserver(() => {
            this.updateButtonVisibility();
          });
          
          this.observer.observe(container, {
            childList: true,
            subtree: true
          });
          
          // Первоначальная проверка
          this.updateButtonVisibility();
        }
      }, 100);
      
      // Таймаут на случай если контейнер не появится
      setTimeout(() => {
        if (checkContainer) {
          clearInterval(checkContainer);
        }
      }, 5000);
    },
    
    updateButtonVisibility() {
      const toasts = document.querySelectorAll('.Vue-Toastification__toast');
      this.hasNotifications = toasts.length > 0;
      // console.log('ClearAllButton: found', toasts.length, 'notifications'); // Отключен спам в консоли
    },
    
    clearAll() {
      this.$clearAllNotifications();
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';

.clear-all-notifications {
  position: fixed;
  top: $spacing-3;
  right: $spacing-4;
  z-index: 10000;
  
  @include mobile {
    top: calc(56px + #{$spacing-2}); // Под app bar на мобильных
    right: $spacing-2;
  }
}

.clear-all-btn {
  background: $color-white !important;
  border: 1px solid $color-border-light !important;
  box-shadow: $shadow-md !important;
  border-radius: $border-radius-md !important;
  padding: $spacing-2 $spacing-3 !important;
  font-size: $font-size-sm !important;
  text-transform: none !important;
  font-weight: $font-weight-medium !important;
  transition: $transition-all !important;
  
  &:hover {
    box-shadow: $shadow-lg !important;
    transform: translateY(-2px);
  }
  
  @include mobile {
    padding: $spacing-1 $spacing-2 !important;
    font-size: $font-size-xs !important;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

